module.exports = __webpack_public_path__ + "static/media/slider_2.290f7996.webp";